<template>
	<tr id="report_admin_input" style="background: #eee">
		<td></td>
		<td>
			<select name="district" v-model="report.districtid" class="form-control">
				<option v-for="(district,index) in districts" :key="index" :value="district.id">{{district.district}}</option>
			</select>
		</td>
		<td>
			<select name="priority" v-model="report.priority" class="form-control">
				<option v-for="(priority,index) in priorities" :key="index" :value="priority.id">{{ priority.name }}</option>
			</select>
		</td>
		<td><input type="text" class="form-control" id="message" aria-describedby="Message" placeholder="Message" v-model="report.message"></td>
		<td></td>
		<td><button class="btn btn-primary" @click="addReport">Add</button></td>
	</tr>
</template>

<script>
import axios from 'axios'
import config from '@/config'

export default{
	name: 'reporter-admin-input',
	data: function(){
		return {
			priorities: config.reporter.priority,
			districts: config.reporter.districts,
			report:{
				districtid: "0",
				priority: "2"
			}
		}
	},
	computed:{
		pageid: function(){
			return this.$store.state.selectedBot.pageid
		}
	},
	methods: {
		addReport: function(){
			var vm = this
			var report = vm.report
			report.reportby = this.$store.state.userid
			vm.$store.dispatch('loading')
			axios.defaults.headers.common = {
				'AUTHORIZATION': this.$store.getters.securityToken
			};
			axios.post(config.serverUrl + 'problemreport?pageid='+vm.pageid,report)
		    .then(response => {
		      // JSON responses are automatically parsed.
		      var response = response.data
		      if (response.responsecode == 200) {
		      	report.id = response.problemid
		      	report.timestamp = new Date()
		      	vm.report = {
					districtid: "0",
					priority: "2"
				}

				vm.$emit('onAdd',report)
		      }  else if (response.responsecode == 400){
				let message = response.reason ? response.reason : ''
				var isFacebook = vm.$store.state.isFacebook
				vm.$store.dispatch('logout', { 'error': { 'code': response.responsecode , 'message' : message}})
				if (vm.$router.history.current.name != 'login' || vm.$router.history.current.name != 'nigol') {
					
					if (isFacebook) {
							vm.$router.push('/login')
						} else {
							vm.$router.push('/nigol')
						}
				}
			} else {
		      }
		      vm.$store.dispatch('loading')
		    })
		    .catch(e => {
		    	console.error(e)
		    	vm.$store.dispatch('loading')
		    })
		}	
	}
}
</script>


// WEBPACK FOOTER //
// src/components/view/template/reporter/reporter-admin-input.vue